module.exports = __webpack_public_path__ + "static/media/webTemplate1.fd759369.gif";